import React, { useState, useEffect } from "react";
import "./FeedbackForm.scss";
import { sendDataTelegramm } from "../../service/service";

const FeedbackForm = ({ onSubmit, setOpenModal, isModal = false }) => {
  const [email, setEmail] = useState("");
  const [nameSurname, setNameSurname] = useState("");
  const [text, setText] = useState("");
  const [successMessage, setSuccessMessage] = useState(false);

  const resetForm = () => {
    setEmail("");
    setNameSurname("");
    setText("");
  };

  const handleNewsSubmit = (event) => {
    event.preventDefault();

    const messageNews = `<b>New post for Erik Site:</b>\n\n<b>User e-mail:</b>\n\n${email}\n\n<b>User Name and Surname:</b>\n\n${nameSurname}\n\n<b>User text:</b>\n\n${text}`;

    sendDataTelegramm(messageNews)
      .then(() => {
        // Показываем сообщение об успехе
        setSuccessMessage(true);

        // ОЧИЩАЕМ ФОРМУ В ЛЮБОМ СЛУЧАЕ
        resetForm();

        // Если это модалка - закрываем её
        if (setOpenModal) {
          setOpenModal(false);
        }

        // Скрываем сообщение через 2.5 секунды
        setTimeout(() => setSuccessMessage(false), 2500);

        if (onSubmit) {
          onSubmit(true);
        }
      })
      .catch((error) => {
        console.error("Sending error:", error);
        if (onSubmit) {
          onSubmit(false);
        }
      });
  };

  return (
    <div className="home-form__wrapper">
      <form onSubmit={handleNewsSubmit} className="home-form">
        <h2>Leave a request and get a free consultation!</h2>

        <input
          required
          type="text"
          placeholder="Your Name and Surname..."
          value={nameSurname}
          onChange={(e) => setNameSurname(e.target.value)}
        />

        <input
          required
          type="email"
          placeholder="Your e-mail..."
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

        <textarea
          required
          placeholder="Your message..."
          value={text}
          onChange={(e) => setText(e.target.value)}
        ></textarea>

        <button type="submit">SEND</button>
      </form>

      <div className={`success-message ${successMessage ? "active" : ""}`}>
        <p>Message sent successfully!</p>
      </div>
    </div>
  );
};

export default FeedbackForm;
